<div class="menu">
  <nav class="pt-md-5">
    @for (sideBarItem of items; track sideBarItem) {
      <a
        class="btn btn-side-navigation mb-2"
        [routerLink]="sideBarItem.routerLink"
        [routerLinkActive]="['active']">
        <div class="d-flex align-items-center gap-2">
          @if (sideBarItem?.icon) {
            <tabler-icon [icon]="sideBarItem.icon" class="icon"></tabler-icon>
          }
          <span class="label d-inline d-lg-inline">{{
            sideBarItem.label
          }}</span>
        </div>
      </a>
    }
  </nav>

  <div class="footer justify-content-end">
    <a
      class="btn btn-side-navigation mb-2"
      [routerLink]="'/contact-admin'"
      [routerLinkActive]="['active']">
      <div class="d-flex align-items-center gap-2">
        <tabler-icon icon="mail" class="icon"></tabler-icon>
        <span class="label d-inline d-lg-inline">{{
          'NAVIGATION.CONTACT_ADMIN' | translate
        }}</span>
      </div>
    </a>
    <a
      class="btn btn-side-navigation mb-2"
      [routerLink]="'/account'"
      [routerLinkActive]="['active']">
      <div class="d-flex align-items-center gap-2">
        <tabler-icon icon="settings" class="icon"></tabler-icon>
        <span class="label d-inline d-lg-inline">{{
          'NAVIGATION.ACCOUNT' | translate
        }}</span>
      </div>
    </a>
    <button
      type="button"
      class="btn btn-side-navigation mb-2"
      (click)="authFacadeService.logout()">
      <div class="d-flex align-items-center gap-2">
        <tabler-icon icon="logout" class="icon"></tabler-icon>
        <span class="label d-inline d-lg-inline">{{
          'NAVIGATION.LOG_OUT' | translate
        }}</span>
      </div>
    </button>
  </div>
</div>
